exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#spanRegdate{font-size:20px;text-align:right;display:block;margin-right:10px;color:#c1163b}#spanContent{font-size:25px;margin-right:10px;color:#c66a7e}#pid1,#pid2{border-radius:3px 22px;background-color:#5fe0d7;text-align:center;font-size:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a3e7e0f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Yeodetail.vue
// module id = 274
// module chunks = 0